import { render, staticRenderFns } from "./SideNavSearchListItem.vue?vue&type=template&id=504c35f2&scoped=true&"
import script from "./SideNavSearchListItem.vue?vue&type=script&lang=js&"
export * from "./SideNavSearchListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504c35f2",
  null
  
)

export default component.exports